import { render } from "./AddTodoForm.vue?vue&type=template&id=a8a833c2&scoped=true"
import script from "./AddTodoForm.vue?vue&type=script&lang=ts"
export * from "./AddTodoForm.vue?vue&type=script&lang=ts"

import "./AddTodoForm.vue?vue&type=style&index=0&id=a8a833c2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a8a833c2"

export default script